module.exports = __webpack_public_path__ + "img/img39.a53501f5.jpg";